import React from "react";
import { Notifier } from "../../ecosystem";

const VideoVisitRoomMsgs = ({
    disableLaunchButton,
    eCheckinCompleted,
    isTimeToStart,
    isSDCVisit,
    roomOpensTime,
    roomClosingTime,
    roomTimePassed,
}) => {

    const getVideoVisitMessages = () => {
        let message = [];
        if (!roomTimePassed) {
            if (!eCheckinCompleted && isTimeToStart) {
                message.push("Virtual room is now available. Complete eCheck-in to launch visit.")
            } else if (roomOpensTime && (!eCheckinCompleted || !isTimeToStart)) {
                message.push("Virtual room opens at " + roomOpensTime);
            }

            if (isSDCVisit && roomClosingTime && (!eCheckinCompleted || (eCheckinCompleted && disableLaunchButton))) {
                message.push("Room entry closes at " + roomClosingTime);
            }
        }

        return message;
    }

    const videoVisitMsg = getVideoVisitMessages();

    return (videoVisitMsg.length > 0) &&
        <div className="appt-tile__video-visit-message">
            <Notifier>
                {videoVisitMsg.map((videoMsg, videoMsgIndex) => {
                    return <div key={videoMsgIndex}>{videoMsg}</div>;
                })}
            </Notifier>
        </div>;
}

export default VideoVisitRoomMsgs;
